import { RelatedFilesQueryResponseType } from '@/common/queries/relatedFiles/relatedFilesQuery.type.ts';
import { DetailCardItemData } from '@/common/components/DetailCard/DetailCard.types.ts';

export const acceptRelatedFilesDetailCardDataGenerator = (
  data: RelatedFilesQueryResponseType,
): DetailCardItemData[][] =>
  data.map(
    (file) =>
      [
        {
          type: 'default',
          keyName: 'نوع پرونده',
          value: file.file_type.fa_const,
        },
        {
          type: 'default',
          keyName: 'شناسه پرونده',
          value: file.order_id,
          dirLtr: true,
        },
      ] as DetailCardItemData[],
  );
